// ProviderPage.jsx
import React from 'react';
import { useParams } from 'react-router-dom';
import Header from '../../Includes/Header';
import Footer from '../../Includes/Footer';
import "./Provider.css";
import c1 from "../../Includes/Images/verizon.svg";

const RCNProvider = () => {
  const { providerName } = useParams();
  const data = [providerName];

  return (
    <>
      <Header />
      
      <div className="coming-soon-container" style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '60vh',
        textAlign: 'center',
        padding: '2rem'
      }}>
        <img 
          src={c1} 
          alt="Optimum" 
          style={{
            maxWidth: '200px',
            marginBottom: '2rem'
          }}
        />
        
        <h1 style={{
          fontSize: '3rem',
          marginBottom: '1.5rem',
          color: '#0071e3'
        }}>
          Coming Soon
        </h1>
        
        <p style={{
          fontSize: '1.2rem',
          maxWidth: '600px',
          lineHeight: '1.6',
          color: '#555',
          marginBottom: '2rem'
        }}>
          We're working hard to bring you the best information about Optimum services. 
          Our page is under construction and will be available soon with detailed plans, 
          pricing, and exclusive offers.
        </p>
        
        <a 
          href="tel:+1-888-348-6689" 
          style={{
            display: 'inline-block',
            padding: '0.8rem 1.5rem',
            backgroundColor: '#0071e3',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '5px',
            fontWeight: 'bold',
            fontSize: '1.1rem',
            transition: 'background-color 0.3s'
          }}
        >
          Call Now: +1-888-348-6689
        </a>
      </div>
      
      <Footer />
    </>
  );
};

export default RCNProvider;